module.exports = __webpack_public_path__ + "img/logo-1.8d45f548.png";